import { useEffect, useMemo, useRef, useState } from "react";
import { MeetingProvider, createCameraVideoTrack  } from "@videosdk.live/react-sdk";



import { authToken, createMeeting } from "../page_components/videocall/API";




// CSS
import '../styles/videoconference.css'


// VIDEOCALL
import JoinScreen from "../page_components/videocall/JoinScreen";
import MeetingView from "../page_components/videocall/MeetingView";
import ResolutionListener from "../page_components/videocall_new/ResolutionListener";



 
 
const VideoCallNew = ({clearArray,transactionsForOath,handleMergedData,sendPushNotification,handleAdminBase64,adminBase64Image}) => {


    // FOR VIDEOQUALITY
    const getTrack = async () => {
        const track = await createCameraVideoTrack({
          optimizationMode: "motion",
          encoderConfig: "h90p_w160p",
          facingMode: "environment",
          multiStream:true 
        });
        setCustomTrack(track);
      };
    
      let [customTrack, setCustomTrack] = useState();
    
      useEffect(() => {
        getTrack();
      }, []);

    const [useProfileIds_TransactionIds,setUserProfileIds_transactionIds] = useState([]);

    useEffect(()=>{
        
       setUserProfileIds_transactionIds(transactionsForOath.map(transaction => ({
            user_profile   : transaction.user_profile,
            transaction_id : transaction.transaction_id,
            registration_id: transaction.user_transacted.registration_id,

        })))
    },[transactionsForOath])

    const [meetingId, setMeetingId] = useState(null);

 


    const getMeetingAndToken = async (id) => {
        const meetingId = id == null ? await createMeeting({ token: authToken }) : id;
        setMeetingId(meetingId);
    };

    //This will set Meeting Id to null when meeting is left or ended
    const onMeetingLeave = () => {
        setMeetingId(null);
    };


    


    return authToken && meetingId ? (
        customTrack && (
            <MeetingProvider
                config={{
                    
                    meetingId,
                    micEnabled   : true,
                    webcamEnabled: true,
                    // participantId: "xyz",
                    permissions: {
                        askToJoin              : false,
                        toggleParticipantWebcam: false,
                        removeParticipant      : true,
                        endMeeting             : true,
                    },
                    // maxResolution: "hd",
                    // defaultCamera:"front",
                    // multiStream:true
                    customCameraVideoTrack: customTrack,
                }}
                token={authToken}>


                    
                <MeetingView clearArray={clearArray} handleMergedData={handleMergedData} sendPushNotification={sendPushNotification} participantsProfileIds={useProfileIds_TransactionIds}  transactionsForOath={transactionsForOath}  meetingId={meetingId} onMeetingLeave={onMeetingLeave} handleAdminBase64={handleAdminBase64} adminBase64Image={adminBase64Image} />
            </MeetingProvider>
        )
    ) : (
        <JoinScreen getMeetingAndToken={getMeetingAndToken}  transactionsForOath={transactionsForOath}  />
    )
    
    ;
}

export default VideoCallNew;